import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { Scope } from '../scope';
import { Oauth2ScopesService } from '../scopes-service';
import { publishReplay, refCount } from 'rxjs/operators';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-list-oauth2-scopes-page',
  templateUrl: './list-oauth2-scopes-page.component.html',
  styleUrls: ['./list-oauth2-scopes-page.component.scss'],
  standalone: false,
})
export class ListOauth2ScopesPageComponent implements OnInit {
  public dataSource: MatTableDataSource<Scope>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public displayedColumns = ['id', 'name', 'description', 'created', 'updated'];
  public scopes$: Observable<Scope[]> = this.oauth2ScopesService.listScopes().pipe(publishReplay(1), refCount()); // refresh happens by component reinstantiation

  constructor(private oauth2ScopesService: Oauth2ScopesService) {
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit(): void {
    // Connect data table and it's sort/paging plugins
    this.scopes$.subscribe((scopes) => {
      this.dataSource.data = scopes;
    });
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  applyFilter($event: KeyboardEvent): void {
    // Update filter from input
    const filterValue = ($event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    // Ensure we're at start of new filtered result
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
